export const initialState = {
    orgId: "",
    orgName: "",
    reports: [],
    orgAccess: null    
};
  